import { render, staticRenderFns } from "./LifeSysChartSoc.vue?vue&type=template&id=4651fd20&"
import script from "./LifeSysChartSoc.vue?vue&type=script&lang=js&"
export * from "./LifeSysChartSoc.vue?vue&type=script&lang=js&"
import style0 from "./LifeSysChartSoc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports